import { RegistryItem } from '@awp/dynamic-outlet';
import * as components from './components';
import { ComponentName } from './card-check-components';

export const COMPONENT_REGISTER: RegistryItem[] = [
    {
      componentName: ComponentName.CardCheck,
      componentType: components.CardCheckComponent
    },
    {
      componentName: ComponentName.CardQuote,
      componentType: components.CardQuoteCheckComponent
    }
  ];